import { defineStore } from 'pinia'

export const useAlertyStore = defineStore('alerty', () => {
  const alert = ref<string>('')
  const param = ref<Record<string, unknown>>({})
  const showAlerty = ref<boolean>(false)
  let time: ReturnType<typeof setTimeout> | null = null

  function showAlert(message: string, newParam: Record<string, unknown> = {}, timeout: number = 2500) {
    if (time) {
      showAlerty.value = false
      clearTimeout(time)
    }

    setTimeout(() => {
      param.value = newParam
      alert.value = message
      showAlerty.value = true
      time = setTimeout(() => {
        showAlerty.value = false
        alert.value = ''
        param.value = {}
      }, timeout)
    }, 100)
  }

  return {
    alert,
    param,
    showAlerty,

    showAlert,
  }
})
